import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { ReceptScreenActionSettingModalComponent } from './recept-screen-action-setting-modal.component';
import { ReceptScreenActionSettingService } from './recept-screen-action-setting-modal.service';

/**
 * 受付画面動作設定モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    TooltipModule
  ],
  declarations: [
    ReceptScreenActionSettingModalComponent
  ],
  entryComponents: [
    ReceptScreenActionSettingModalComponent
  ],
})
export class ReceptScreenActionSettingModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ReceptScreenActionSettingModule,
      providers: [
        ReceptScreenActionSettingService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/recept-screen-action-setting-modal/recept-screen-action-setting-modal.module.ts